import React from "react";
import dateFns from "date-fns";

interface CalendarCellsProps {
  newDate: Date;
  isAllowSelect: Function;
  onClickDate: Function;
}

const CalendarCells = ({ newDate, isAllowSelect, onClickDate }: CalendarCellsProps) => {
  const monthStart = dateFns.startOfMonth(newDate);
  const monthEnd = dateFns.endOfMonth(monthStart);
  const startDate = dateFns.startOfWeek(monthStart, { weekStartsOn: 1 });
  const endDate = dateFns.endOfWeek(monthEnd, { weekStartsOn: 1 });
  const dateFormat = "DD";

  const rows = [];
  let days = [];
  let day = startDate;
  let formattedDate = "";
  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      formattedDate = dateFns.format(day, dateFormat);
      const cloneDay = day;
      days.push(
        <div
          className={`col cell ${
            !dateFns.isSameMonth(day, monthStart)
              ? " disabled"
              : !isAllowSelect(day)
              ? " no-allow"
              : dateFns.isSameDay(day, newDate)
              ? " selected"
              : ""
          }`}
          key={dateFns.format(day, "DD-MM-YYYY")}
          onClick={() => onClickDate(dateFns.parse(cloneDay), true)}
        >
          <div>
            <p>{formattedDate}</p>
          </div>
        </div>
      );
      day = dateFns.addDays(day, 1);
    }
    rows.push(
      <div className="row" key={dateFns.format(day, "DD-MM-YYYY")}>
        {days}
      </div>
    );
    days = [];
  }

  return <div className="body">{rows}</div>;
};

export default CalendarCells;
